import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tab-pane fade active show" }
const _hoisted_2 = { class: "card card-flush" }
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-measure fa-4x" }, null, -1)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "me-3 rotate-90" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z",
        fill: "black"
      })
    ])
  ])
], -1)
const _hoisted_9 = { class: "me-3" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "text-gray-800 fw-bolder" }
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "d-flex flex-wrap py-5" }
const _hoisted_14 = { class: "flex-equal me-5" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-12 col-md-2 col-lg-1" }
const _hoisted_17 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_18 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_19 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_20 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_21 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_22 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_23 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_24 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_25 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_26 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_27 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_28 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_29 = { class: "col-12 col-md-3 col-lg-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_VerticalBullet = _resolveComponent("VerticalBullet")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.availableMeasurements.length === 0)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              description: "No one in your production has saved measurements to their account."
            }, {
              image: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.availableMeasurements, (measurement) => {
              return (_openBlock(), _createElementBlock("div", {
                key: measurement.measurementId,
                class: "d-flex flex-column"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "d-flex align-items-center collapsible rotate collapsed",
                      "data-bs-toggle": "collapse",
                      href: `#measurement_row_${measurement.measurementId}`,
                      role: "button",
                      "aria-expanded": "true"
                    }, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getPerson(measurement.accountId).fullName), 1)
                        ])
                      ])
                    ], 8, _hoisted_7)
                  ]),
                  _createElementVNode("div", {
                    id: `measurement_row_${measurement.measurementId}`,
                    class: "fs-6 ps-10 collapse"
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Height: ${measurement.height}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Weight: ${measurement.weight}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Chest: ${measurement.chest}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Waist: ${measurement.waist}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Hip: ${measurement.hip}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Outseam: ${measurement.outseam}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Inseam: ${measurement.inseam}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Neck Size: ${measurement.neckSize}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Sleeve Length: ${measurement.sleeveLength}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Hat: ${measurement.hat}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Shoulder: ${measurement.shoulder}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Nape to Waist: ${measurement.napeWaist}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Nape to Floor: ${measurement.napeFloor}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_VerticalBullet, {
                              text: `Shoe: ${measurement.shoe}${_ctx.getUnit(measurement)}`,
                              color: "rust"
                            }, null, 8, ["text"])
                          ])
                        ])
                      ])
                    ])
                  ], 8, _hoisted_12)
                ]),
                _hoisted_30
              ]))
            }), 128))
      ])
    ])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}